import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 rounded-full bg-secondary/50">
        <Sun className="h-4 w-4" />
        <div className="w-10 h-5 rounded-full bg-muted" />
        <Moon className="h-4 w-4" />
      </div>
    );
  }

  const isDark = theme === "dark";

  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-full bg-secondary border border-border hover:border-accent transition-colors">
      <button
        onClick={() => setTheme(isDark ? "light" : "dark")}
        className="relative w-11 h-6 rounded-full bg-muted transition-colors focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2"
        role="switch"
        aria-checked={isDark}
        aria-label="Toggle dark mode"
      >
        <span
          className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full shadow-md transition-all duration-300 ease-in-out flex items-center justify-center ${
            isDark ? 'translate-x-5 bg-accent' : 'translate-x-0 bg-accent'
          }`}
        >
          {isDark ? (
            <Moon className="h-3 w-3 text-background" />
          ) : (
            <Sun className="h-3 w-3 text-background" />
          )}
        </span>
      </button>
      <span className="text-xs text-muted-foreground whitespace-nowrap">Come to the dark side!</span>
    </div>
  );
}
